export const isVehicleSearchCard = (): boolean => {
    const pathname = window.location.pathname.toLowerCase()
    return (
        pathname.endsWith('vehicle-ci') ||
        pathname.endsWith('vehicle-presale') ||
        pathname.endsWith('vehicle-deals') ||
        pathname.endsWith('vehicle-dealer')
    )
}
